import { useEffect, useRef } from "react";
import * as THREE from "three";

export default function DotsBackground() {
  const backgroundRef = useRef(null);

  useEffect(() => {
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");
    let effect;
    let disposed = false;
    let DOTS;

    function syncEffect() {
      effect?.destroy();
      effect = undefined;
      if (disposed || reducedMotion.matches || !DOTS) return;

      try {
        effect = DOTS({
          el: backgroundRef.current,
          THREE,
          backgroundAlpha: 1,
          backgroundColor: 0x000000,
          color: 16777213,
          color2: 15461355,
          gyroControls: false,
          minHeight: 200,
          minWidth: 200,
          mouseControls: true,
          scale: 1,
          scaleMobile: 1,
          showLines: true,
          size: 1.2,
          spacing: 26,
          touchControls: true,
        });
      } catch (error) {
        // Keep the plain black background when WebGL is unavailable.
        console.warn("Vanta Dots could not initialize:", error);
      }
    }

    // Dots 0.5.24 captures window.THREE when its module is evaluated.
    window.THREE = THREE;
    import("vanta/dist/vanta.dots.min").then((module) => {
      if (disposed) return;
      DOTS = module.default;
      syncEffect();
    }).catch((error) => {
      console.warn("Vanta Dots could not load:", error);
    });
    reducedMotion.addEventListener("change", syncEffect);
    return () => {
      disposed = true;
      reducedMotion.removeEventListener("change", syncEffect);
      effect?.destroy();
    };
  }, []);

  return <div ref={backgroundRef} className="dots-background" aria-hidden="true" />;
}
